import { gql } from "@apollo/client";

export default gql`
  fragment AssessmentQuestionCoreValue on RecognitionCoreValueNode {
    id
    title
    description
    emoji
    image
  }
`;
